import { render, staticRenderFns } from "./communityComplaintAdvice-dialog.vue?vue&type=template&id=05ba2fc5&scoped=true&"
import script from "./communityComplaintAdvice-dialog.vue?vue&type=script&lang=js&"
export * from "./communityComplaintAdvice-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba2fc5",
  null
  
)

export default component.exports